import type { ModuleDefinition } from '~/platform/registry/types';

import { dashboardModule } from './dashboard';
import { ordersModule } from './orders';
import { groupingModule } from './grouping';
import { marketModule } from './market';
import { purchasingModule } from './purchasing';
import { suppliersModule } from './suppliers';
import { logisticsModule } from './logistics';
import { deliveriesModule } from './deliveries';
import { catalogModule, productsModule } from './catalog';
import { stockModule } from './stock';
import { contactsModule } from './contacts';
import { messagingModule } from './messaging';
import { scheduleModule } from './schedule';
import { invoicesModule } from './invoices';
import { paymentsModule } from './payments';
import { analyticsModule } from './analytics';
import { teamModule } from './team';
import { settingsModule } from './settings';

/* ------------------------------------------------------------------ *
 * The only place that knows every module exists.
 *
 * Adding a feature next year is: create the folder, export a
 * ModuleDefinition, add one line here, add its namespace to the three
 * locale files. Navigation, routing, permissions, the command palette,
 * global search and code-splitting all follow automatically.
 *
 * Nothing here decides what a *tenant* sees — that is
 * `business.enabledModules` crossed with the user's grants, resolved
 * in `resolveRegistry`.
 * ------------------------------------------------------------------ */

export const MODULES: ModuleDefinition[] = [
  dashboardModule,
  ordersModule,
  groupingModule,
  marketModule,
  catalogModule,
  productsModule,
  purchasingModule,
  suppliersModule,
  logisticsModule,
  deliveriesModule,
  stockModule,
  contactsModule,
  messagingModule,
  scheduleModule,
  invoicesModule,
  paymentsModule,
  analyticsModule,
  teamModule,
  settingsModule,
];
